import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { theme } from '../../../domain/theme';

const styles = {
  headerSection: css`
    padding: 56px 20px 44px 20px;
    ${theme.mq.tablet} {
      padding: 80px 50px 60px 50px;
    }
  `,
  headerContainer: css`
    display: grid;
    gap: 20px;
    margin-bottom: 20px;
    text-align: center;
  `,
  title: css`
    ${theme.font.family('boldWeb')};
    font-size: 32px;
    line-height: 1.42;
    letter-spacing: 3.6px;
    text-transform: uppercase;
    ${theme.mq.small_desktop} {
      font-size: 44px;
      line-height: 1;
    }
  `,
  description: css`
    ${theme.font.family('regularWeb')};
    font-size: 18px;
    letter-spacing: 0;
    line-height: 1.5;
  `,
  hr: css`
    display: block;
    width: 40px;
    height: 3px;
    margin: 0 auto;
    border: none;
    background-color: #fc0;
  `
};

export const ContentPackageHeaderSection = ({ title, description }) => {
  return (
    <section css={styles.headerSection}>
      <div css={styles.headerContainer}>
        {title && <h2 css={styles.title}>{title}</h2>}
        {description && <p css={styles.description}>{description}</p>}
      </div>
      <hr css={styles.hr} />
    </section>
  );
};

ContentPackageHeaderSection.defaultProps = {
  title: undefined,
  description: undefined
};

ContentPackageHeaderSection.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string
};
